import {v4 as uuid} from 'uuid';

const openModals = [];

/* --- actions ---*/
const OPEN_MODAL = 'OPEN_MODAL';
const CLOSE_MODAL = 'CLOSE_MODAL';
const CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS';

/* -- action creators -- */
export const _openModal = (modal) => dispatch => {
  dispatch({
    type: OPEN_MODAL,
    modal: {
      ...modal,
      id: (modal.type || modal.componentName) + '-' + uuid(),
    },
  });
};

export const _removeModal = (modal) => dispatch => {
  dispatch({
    type: CLOSE_MODAL,
    modal,
  });
};

export const _removeAllModals = () => dispatch => {
  dispatch({
    type: CLOSE_ALL_MODALS,
  });
};

// ETODO state should be restructured to be an object with a modals array prop, not simply an array of modals
// this would allow additional modal state to be tracked

/* --- reducer ---*/
export default function reducer(state = openModals, action) {
  const index = state.indexOf(action.modal);
  let newState;
  switch (action.type) {
    case OPEN_MODAL:
      newState = [...state, action.modal];
      break;
    case CLOSE_MODAL:
      newState = [...state];
      newState.splice(index, 1);
      break;
    case CLOSE_ALL_MODALS:
      newState = [];
      break;
    default:
      return state;
  }

  return newState;
}
